module.exports = __webpack_public_path__ + "img/custom_plumber03.aa978930.jpg";